import ReactEcharts from 'echarts-for-react';
import React from 'react';
import { isAdmin } from 'utils/isAdmin';

const BarChart = ({ data = [] }) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const options = {
    title: {
      text: 'L out',
      left: 'left',
      textStyle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#5470c6',
      },
    },
    grid: { top: 40, right: 20, bottom: 40, left: 50 },
    xAxis: {
      type: 'category',
      data: ['L1', 'L2', 'L3'],
      axisLabel: {
        fontSize: 14,
        color: isAdminRoute,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontSize: 14,
        color: isAdminRoute,
      },
      splitLine: {
        lineStyle: {
          color: '#eee',
        },
      },
    },
    series: [
      {
        data: data.length > 0 ? data.map((item) => item[2]) : [10, 20, 30],
        type: 'bar',
        barWidth: '30%', // Adjust bar width
        itemStyle: {
          borderRadius: [10, 10, 0, 0], // Rounded top corners
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: '#82b1ff' }, // Top color
              { offset: 1, color: '#448aff' }, // Bottom color
            ],
          },
        },
      },
    ],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
  };
  return (
    <div>
      <ReactEcharts
        option={options}
        style={{ width: '400px', height: '400px' }}
        onEvents={() => {}}
      ></ReactEcharts>
    </div>
  );
};

export default BarChart;
